module.exports = __webpack_public_path__ + "static/media/help-img-2-1.dc515d42.png";